var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAstroF(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_88_2323)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6794 12.9025H28C28 6.03001 21.7179 0.458008 15.5042 0.458008V9.79134C15.5042 11.5102 16.9628 12.9025 18.6794 12.9025ZM15.5725 16.0136H24.8931C24.8931 23.7027 17.912 29.7631 9.9553 28.2153C5.11013 27.2727 1.18771 23.362 0.246329 18.5102C-1.29934 10.5426 4.63012 3.56912 12.3973 3.56912V12.9025C12.3973 14.6213 13.856 16.0136 15.5725 16.0136Z",
    fill: "#FFB21D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_88_2323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0 0.458008)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAstroF);
export default __webpack_public_path__ + "static/media/astroF.5b15e90100346fdb55d85bd5513829e6.svg";
export { ForwardRef as ReactComponent };